import { isValidEmail } from 'utils/stringHelpers';

export const validateCommaSeparatedEmails = (value: string) => {
  const trimmed = value.trim();
  const values = trimmed
    .split(',')
    .map((v) => v.trim())
    .filter((v) => !!v);
  return values.every(isValidEmail);
};
